import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Autocomplete, Typography } from "@maysoft/common-component-react";

import Strings from "constants/strings";

import { Mode } from "constants/enum";
import { ICodename, IDataDetailReport, IErrorReport } from "commons/interfaces";



const CardNotification = ({
    mode,
    data,
    error,
    dataOptions,
    handleChangeValue,
}: {
    mode: Mode,
    error: IErrorReport;
    data: IDataDetailReport;
    handleChangeValue: (key: string, value: any) => void;
    dataOptions: {
        level: ICodename[];
        common: ICodename[];
        classtify: ICodename[];
    };
}) => {

    return (
        <Card sx={{ padding: 3 }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {Strings.REPORT.NOTIFICATION}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        mode={mode}
                        isSelectedBox
                        variant={"outlined"}
                        data={dataOptions.common}
                        label={Strings.REPORT.FOR_DOCTOR}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        defaultValue={data?.reportedToPersonInCharge}
                        errorMessage={error?.reportedToPersonInCharge}
                        onChange={(value) => {
                            handleChangeValue("reportedToPersonInCharge", value);
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        mode={mode}
                        isSelectedBox
                        variant={"outlined"}
                        data={dataOptions.common}
                        defaultValue={data?.reportedToDocument}
                        errorMessage={error?.reportedToDocument}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        label={Strings.REPORT.MEDICAL_RECORD_RELATIVE}
                        onChange={(value) => {
                            handleChangeValue("reportedToDocument", value);
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        mode={mode}
                        isSelectedBox
                        variant={"outlined"}
                        data={dataOptions.common}
                        label={Strings.REPORT.FOR_HOMIE}
                        defaultValue={data?.reportedToRelative}
                        errorMessage={error?.reportedToRelative}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        onChange={(value) => {
                            handleChangeValue("reportedToRelative", value);
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        mode={mode}
                        isSelectedBox
                        variant={"outlined"}
                        data={dataOptions.common}
                        label={Strings.REPORT.FOR_PATIENT}
                        defaultValue={data?.reportedToPatien}
                        errorMessage={error?.reportedToPatien}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        onChange={(value) => {
                            handleChangeValue("reportedToPatien", value);
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        mode={mode}
                        isSelectedBox
                        variant={"outlined"}
                        data={dataOptions.classtify}
                        label={Strings.REPORT.CLASSIFY_INCIDENT}
                        defaultValue={data?.firstClassification}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        errorMessage={error?.firstClassification}
                        onChange={(value) => {
                            handleChangeValue("firstClassification", value);
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        mode={mode}
                        isSelectedBox
                        variant={"outlined"}
                        data={dataOptions.level}
                        label={Strings.REPORT.EVALUATE_INCIDENT}
                        defaultValue={data?.firstAffectValuation}
                        placeholder={Strings.COMMON.SELECT_VALUE}
                        errorMessage={error?.firstAffectValuation}
                        onChange={(value) => {
                            handleChangeValue("firstAffectValuation", value);
                        }}
                    />
                </Grid>
            </Grid>
        </Card>
    );
}

export default CardNotification;